import { RequiredTranslationsTemplate } from '.'

const en: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'English',
  },
  home: {
    title: 'PRODUCT RECALL - ROCKRIDER XC500S',
    description:
      'Thank you for purchasing a ROCKRIDER XC500S mountain bike (MTB). We have identified a potential weakness in the front fork. Only certain bikes are defective. Please enter the 30 digits of your Bike Traceability number, to confirm if your bike is affected by this recall:',
    form: {
      title: 'Please enter the following information:',
      fields: {
        serialNumber: 'Bike traceability number:',
        serialNumberFamily: 'N° série (start)',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Telephone',
        country: 'Country',
        submit: 'Submit',
        choose: 'Choose...',
      },
      errors: {
        requiredField: 'Required Field',
        unknownSerialNumber: 'Unknown Serial Number',
        provide6Numbers: 'attention 6 digits are necessary',
      },
      confirmations: {
        good: {
          title: 'Your bike is not affected',
          p1: 'Please be advised that your bike is not affected by this recall. Please continue to enjoy riding your bike.',
          p2: 'We apologise for any inconvenience caused,',
          p3: 'Yours sincerely,',
          p4: 'The Decathlon team',
        },
        defective: {
          title: 'Your bike is unfortunately affected.',
          p1: 'We ask you to stop using this bike immediately and to contact your nearest Decathlon Store, in order to replace the fork.',
          p2: 'Please note you may be unable to use your bike for several days during the repair. Rest assured we will do our utmost to minimise these delays. We advise you to consult directly with the workshop of your selected Decathlon Store, to have an estimate of the repair time.',
          p3: 'To find the closest Decathlon Workshop to you:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'You will find below your “Customer Return Notice” to present to our Technician when you return to the workshop:',
          p5: 'For more information, please contact our dedicated contact centre for this product recall, 0 805 38 38 49, free of charge from metropolitan France (open Monday to Friday from 9am to 7pm) or by email at rappel.decathlon@fandi.fr',
        },
      },
    },
    findTheSerialNumber: {
      title: 'How to find you Bike Traceability number:',
      description:
        'The 30 digit number is printed on the underside of your bike frame, close to the bottom bracket and pedals. See the image below.',
    },
  },
}

export default en
